module.exports = "//docs.gtimg.com/slide/img/framework/frame/components/animation-editor/images/ai-photo-maker-0ad641.svg";